import { SVGProps } from '@components/Icon/types';

export const Bold = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(7.0008, 5)">
      <path
        d="M0 14V0H5.37665C6.29316 0 7.04331 0.191204 7.62712 0.573611C8.2172 0.949537 8.65348 1.43241 8.93597 2.02222C9.22473 2.61204 9.36912 3.2213 9.36912 3.85C9.36912 4.6213 9.19021 5.27593 8.83239 5.81389C8.48085 6.35185 8.00063 6.71482 7.39171 6.90278V6.41667C8.24545 6.61759 8.89203 7.03565 9.33145 7.67083C9.77715 8.30602 10 9.0287 10 9.83889C10 10.6685 9.8462 11.3944 9.53861 12.0167C9.23101 12.6389 8.77276 13.125 8.16384 13.475C7.56121 13.825 6.81419 14 5.92279 14H0ZM2.29755 11.7931H5.6403C6.03578 11.7931 6.39046 11.712 6.70433 11.55C7.0182 11.3815 7.26303 11.1481 7.43879 10.85C7.62084 10.5454 7.71186 10.1856 7.71186 9.77083C7.71186 9.39491 7.6334 9.05787 7.47646 8.75972C7.31952 8.46157 7.0904 8.225 6.78908 8.05C6.48776 7.86852 6.1268 7.77778 5.70621 7.77778H2.29755V11.7931ZM2.29755 5.59028H5.3484C5.67483 5.59028 5.96673 5.52546 6.22411 5.39583C6.48148 5.2662 6.6855 5.075 6.83616 4.82222C6.98682 4.56945 7.06215 4.25833 7.06215 3.88889C7.06215 3.40278 6.91149 2.99769 6.61017 2.67361C6.30885 2.34954 5.88826 2.1875 5.3484 2.1875H2.29755V5.59028Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'bold';
